exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Testimonials .btn.btn-left,.Testimonials .btn.btn-right{display:none}.Testimonials .indicators{position:absolute;transform:translateX(0)!important;left:30px!important}.Testimonials .indicators .slider-indicator-active{background-color:#00a0d1}.testimonials-empty{padding-top:4.5em}.testimonials-empty i{font-size:15em;opacity:.3}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-5c7945f1","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/testimonials/Testimonials.vue
// module id = 270
// module chunks = 0